/**
 * @GENERATED from Figma node 693:15970
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const ZendeskBright = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#07363D"
      d="M12.786 4v11.429L23 4zM6.107 9.09c2.794 0 5.107-2.606 5.107-5.09H1c0 2.484 2.313 5.09 5.107 5.09M12.786 20c0-2.484 2.313-5.09 5.107-5.09S23 17.515 23 20zM11.214 20V8.571L1 20z"
    />
  </svg>
);
const ForwardRef = React.forwardRef(ZendeskBright);
export { ForwardRef as ZendeskBright };
